<section class="flex flex-col items-center max-width-lg">
  <div class="flex flex-col items-center ta-center">
    <div class="mat-headline-2">{{ 'DASHBOARD.OUR_SERVICES' | transloco }}</div>
  </div>

  <div *ngIf="lineOfBusinesses" class="flex flex-row flex-wrap w-100-percent mr--12 ml--12">
    <app-carousel [items]="lineOfBusinesses" [numDisplayedItems]="4">
      <ng-template let-lineOfBusiness>
        <app-line-of-business-card class="flex card-width w-100-percent" [lineOfBusiness]="lineOfBusiness">
        </app-line-of-business-card>
      </ng-template>
    </app-carousel>
  </div>
</section>
